import { render, staticRenderFns } from "./InstantForm.vue?vue&type=template&id=77a18670&scoped=true&"
import script from "./InstantForm.vue?vue&type=script&lang=js&"
export * from "./InstantForm.vue?vue&type=script&lang=js&"
import style0 from "./InstantForm.vue?vue&type=style&index=0&id=77a18670&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a18670",
  null
  
)

export default component.exports